import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from '../../lib/utils'

export function Card({
  className,
  children,
  ...rest
}: HTMLAttributes<HTMLDivElement> & { children: ReactNode }) {
  return (
    <div
      className={cn(
        // Glass surface — cosmic depth with hairline border that lights up cyan on focus-within
        'rounded-lg border border-zinc-800/70 bg-zinc-900/50 backdrop-blur-md',
        'shadow-[0_1px_0_0_rgba(255,255,255,0.03)_inset,0_0_0_1px_rgba(0,0,0,0.3),0_8px_24px_-12px_rgba(0,0,0,0.6)]',
        'transition-[border-color,box-shadow] duration-200',
        'focus-within:border-cyan-500/40 focus-within:shadow-[0_1px_0_0_rgba(255,255,255,0.03)_inset,0_0_0_1px_rgba(34,211,238,0.2),0_0_24px_-6px_rgba(34,211,238,0.25)]',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  )
}

export function CardHeader({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn('px-5 py-4 border-b border-zinc-800/70', className)}>{children}</div>
}

export function CardTitle({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <h3
      className={cn('font-display text-base font-semibold tracking-tight text-zinc-50', className)}
    >
      {children}
    </h3>
  )
}

export function CardDescription({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  return <p className={cn('text-sm text-zinc-400 mt-0.5', className)}>{children}</p>
}

export function CardBody({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn('p-5', className)}>{children}</div>
}

export function CardFooter({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div
      className={cn('px-5 py-3 border-t border-zinc-800/70 bg-zinc-950/40 rounded-b-lg', className)}
    >
      {children}
    </div>
  )
}
